<template>
    <div class="space-y-4">
        <!-- Pricing Tiers Section -->
        <div>
            <label class="block text-sm mb-1.5">
                Pricing tiers
            </label>

            <div class="bg-white border rounded divide-y mb-2">
                <div
                    v-for="(tier, index) in data.pricing_tiers"
                    :key="index"
                    class="p-3 space-y-2"
                >
                    <div class="flex items-center justify-between">
                        <span class="text-sm">Tier {{ index + 1 }}</span>
                        <btn type="light" size="xs" @click="removeTier(index)">
                            <icon name="delete" size="14" class="mr-1" />
                            Delete
                        </btn>
                    </div>
                    <text-field
                        :name="'tier_name_' + index"
                        v-model="tier.name"
                        placeholder="Plan name"
                    />
                    <div class="grid grid-cols-2 gap-2">
                        <text-field
                            :name="'tier_monthly_' + index"
                            v-model.number="tier.monthly_price"
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="Monthly price"
                        />
                        <text-field
                            :name="'tier_yearly_' + index"
                            v-model.number="tier.yearly_price"
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="Yearly price"
                        />
                    </div>
                </div>
            </div>

            <btn type="secondary" size="small" @click="addTier">
                Add tier
            </btn>
        </div>

        <div>
            <span class="block text-xs text-gray-900 mb-0.5">Type</span>
            <select
                v-model="data.calculation_type"
                class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 pr-6 bg-transparent cursor-pointer"
            >
                <option value="recurring">Customer-based (recurring)</option>
                <option value="one_time">Sales-based</option>
            </select>
        </div>

        <div class="flex justify-between items-start">
            <div>
                <span class="block text-xs text-gray-900 mb-0.5">Min</span>
                <input
                    v-model.number="data.slider_min"
                    type="number"
                    min="1"
                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 bg-transparent w-12"
                    placeholder="1"
                />
            </div>
            <div>
                <span class="block text-xs text-gray-900 mb-0.5">Default</span>
                <input
                    v-model.number="data.slider_default"
                    type="number"
                    min="1"
                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 bg-transparent w-12"
                    placeholder="100"
                />
            </div>
            <div>
                <span class="block text-xs text-gray-900 mb-0.5">Max</span>
                <input
                    v-model.number="data.slider_max"
                    type="number"
                    min="1"
                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 bg-transparent w-12"
                    placeholder="500"
                />
            </div>
        </div>

        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
            <toggle
                v-model="data.show_calculator"
                size="medium"
                title="Show earnings calculator"
            />
            <toggle
                v-model="data.show_earnings_table"
                size="medium"
                title="Show earnings table"
            />
            <toggle
                v-model="data.show_next_tier"
                size="medium"
                title="Show next tier"
            />
            <toggle
                v-model="data.show_earnings_heading"
                size="medium"
                title="Show earnings heading"
            />
        </div>

    </div>
</template>

<script>
export default {
    props: ['data', 'unique_id'],

    created() {
        // Initialize pricing_tiers if not present
        if (!this.data.pricing_tiers) {
            this.data.pricing_tiers = [];
        }
        if (!this.data.pricing_tiers.length) {
            this.data.pricing_tiers.push({
                name: '',
                monthly_price: null,
                yearly_price: null
            });
        }
        // Initialize other defaults
        if (this.data.calculation_type === undefined) {
            this.data.calculation_type = 'recurring';
        }
        if (this.data.slider_min === undefined) {
            this.data.slider_min = 1;
        }
        if (this.data.slider_default === undefined) {
            this.data.slider_default = 100;
        }
        if (this.data.slider_max === undefined) {
            this.data.slider_max = 500;
        }
        if (this.data.show_calculator === undefined) {
            this.data.show_calculator = true;
        }
        if (this.data.show_earnings_table === undefined) {
            this.data.show_earnings_table = false;
        }
        if (this.data.show_next_tier === undefined) {
            this.data.show_next_tier = false;
        }
        if (this.data.show_earnings_heading === undefined) {
            this.data.show_earnings_heading = true;
        }
    },

    methods: {
        addTier() {
            this.data.pricing_tiers.push({
                name: '',
                monthly_price: null,
                yearly_price: null
            });
        },

        removeTier(index) {
            this.data.pricing_tiers.splice(index, 1);
        }
    }
}
</script>
